import React from "react";
import { ReactComponent as ArrowBackIcon } from "assets/images/common/svgs/arrow_back.svg";
import cardsBg from "assets/images/common/others/cardsBg.png";
import cardProfilePic from "assets/images/common/others/cardProfilePic.png";
import { ReactComponent as ReviewIcon } from "assets/images/common/svgs/reviewGolden.svg";

interface Attendee {
  id: number;
  name: string;
  profileImage: string;
}

const dummyData: Attendee[] = [
  {
    id: 1,
    name: "John Doe",
    profileImage: cardProfilePic,
  },
  {
    id: 2,
    name: "Jane Smith",
    profileImage: cardProfilePic,
  },
  {
    id: 3,
    name: "Robert Brown",
    profileImage: cardProfilePic,
  },
  {
    id: 1,
    name: "John Doe",
    profileImage: cardProfilePic,
  },
  {
    id: 2,
    name: "Jane Smith",
    profileImage: cardProfilePic,
  },
];
const FavoriteHost = () => {
  return (
    <div>
      <div className="flex flex-wrap items-center gap-4 py-5">
        {dummyData.map((item) => (
          <div
            key={item.id}
            className="flex flex-col items-center justify-center p-4  min-w-[235px] min-h-[259px] cursor-pointer bg-cover bg-center bg-no-repeat rounded-3xl"
            style={{ backgroundImage: `url(${cardsBg})` }}
          >
            <div className="hover:scale-110 transition-transform duration-300">
              <img
                className="w-[100px] h-[100px] object-cover rounded-full"
                src={item.profileImage}
                alt={item.name}
              />
            </div>
            <span className="text-base font-semibold my-2 text-primaryText">
              {item.name}
            </span>
            <div className="flex justify-center gap-2">
              <span className="">
                <ReviewIcon />
              </span>
              <span className="text-sm  text-primaryText">(5.0)</span>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FavoriteHost;
